import { Link } from 'gatsby';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledNumberListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0;

  & li:not(:last-child) {
    margin-bottom: ${rem('62px')};

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
      margin-bottom: 0;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    justify-content: space-evenly;
  }
`;

export const StyledNumberSetContainer = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${rem('170px')};

  & a:not(:last-child) {
    margin-bottom: ${rem('10px')};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    & a:not(:last-child) {
      margin-bottom: ${rem('8px')};
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: ${rem('210px')};
  }
`;

export const StyledNumberSetContainerLink = styled(Link)`
  color: ${({ theme }) => theme.colors.mainAlternate};
`;

export const StyledNumber = styled.a`
  font-weight: 700;
  font-size: ${rem('32px')};
  line-height: ${rem('32px')};
  margin: 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    font-size: ${rem('56px')};
    line-height: ${rem('64px')};
  }
`;

export const StyledDescriptionText = styled.a`
  font-weight: 700;
  font-size: ${rem('16px')};
  width: ${rem('180px')};
  text-align: center;
  color: ${({ theme }) => theme.colors.cross.grayson};
`;
